
import babelPolyfill from 'babel-polyfill';

import { VueReCaptcha } from 'vue-recaptcha-v3'
Vue.use(VueReCaptcha, { siteKey: '6LeNFYkdAAAAAGsy9ZG84-gn5efH3c3zmGxtDhQ1' });

 
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/index'

import Vuex from 'vuex'

import axios from 'axios'
import VueAxios from 'vue-axios'

Vue.use(Vuex);

Vue.use(VueAxios, axios)
const baseURL = 'https://webapi.inchcape.carsalesflow.pl/';
// const baseURL = 'https://webapi.demo.csflow.pl/';

Vue.axios.defaults.baseURL = baseURL;

import SelectInput from './components/elements/select-input.vue';
Vue.component('SelectInput',SelectInput);


Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
